import { render } from "./ProjectInfo.vue?vue&type=template&id=023d63f7&scoped=true"
import script from "./ProjectInfo.vue?vue&type=script&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&lang=js"

import "./ProjectInfo.vue?vue&type=style&index=0&id=023d63f7&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/src/sites/hamiane-site-quasar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023d63f7"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QRating from 'quasar/src/components/rating/QRating.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIntersection from 'quasar/src/components/intersection/QIntersection.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QCheckbox,QBtn,QCard,QTabs,QTab,QIcon,QTooltip,QRating,QAvatar,QIntersection,QInnerLoading,QSpinnerDots,QChip,QDialog,QSeparator,QPageSticky,QImg,QTimeline});
